import 'components/sidebar/index.css'
import './index.css'
import * as React from 'react'
import Slider from 'components/ui/rc-slider'
type Props = {
  label: string | React.ReactNode
  step: number
  val: number[]
  setVal: (...args: Array<any>) => any
  formatter?: (...args: Array<any>) => any
  disabled?: boolean
  sliderRange: number[]
  constantlyActive?: boolean
  showFilters?: boolean
}

const SidebarSlider = ({
  label,
  step,
  val,
  setVal,
  formatter,
  disabled,
  sliderRange,
}: Props): React.ReactElement<'div'> => {
  const [startRange, endRange] = sliderRange
  let color = '#5f63ee'
  return (
    <div className="SidebarSlider">
      <div className="SidebarSlider_LabelContainer">
        <div className="SidebarSlider_Label">{label}</div>
        <div className="SidebarSlider_ButtonContainer">
          <button
            className="SidebarSlider_Button"
            onClick={() => setVal(sliderRange)}
          >
            ✕
          </button>
        </div>
      </div>
      <div className="SidebarSlider_RangeWrapper">
        <div className="SidebarSlider_Range">
          <Slider
            range
            disabled={disabled}
            trackStyle={[
              {
                backgroundColor: color,
              },
            ]}
            min={startRange}
            max={endRange}
            step={step}
            value={val}
            onChange={setVal}
            allowCross={false}
            handleRender={(node, handleProps) => (
              <>
                {node}
                <div className="SidebarSlider_Tooltip" style={node.props.style}>
                  {formatter ? formatter(handleProps.value) : handleProps.value}
                </div>
              </>
            )}
          />
        </div>
      </div>
    </div>
  )
}

export default SidebarSlider
